// extracted by mini-css-extract-plugin
module.exports = {"back":"SmallForm_back__2lzp0","organizar":"SmallForm_organizar__2wb_F","caja":"SmallForm_caja__1QKcn"};